export const TEST_ID = 'skeletonGroup';
